import { useState, useEffect } from 'react';
import { componentCheckSize } from '../../../utils/helperServices';
import HighLighter from '../textHighlighter/TextHighlighter';
import styles from './UpgradeDropdown.module.scss';

const mWidth = 320; // 576

const UpgradeDropdown = ({ selectedValue, optionsList, handleSelect, className, selectClass, dropdownClass, containerclass, showIcon }) => {

    const [showOptionList, setShowOptionList] = useState(false);
    const isMobile = componentCheckSize() < mWidth;

    const handleClickOutside = (e) => {
        if (
            !e.target.classList.contains(styles["select__option"]) &&
            !e.target.classList.contains(styles["select__text"])
        ) {
            setShowOptionList(false);
        }
    };

    const handleListDisplay = () => {
        if (!isMobile) {
            setShowOptionList((prevState) => !prevState);
        }
    };

    const optionClick = (e) => {
        setShowOptionList(false);
        handleSelect(e.target.getAttribute("data-value"));
    };

    useEffect(() => {
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    });

    return (
        <div className={`${styles["new-select"]} ${containerclass}`}>
            {!isMobile ? <div
                className={`${styles.select} ${styles["select__class"]
                    }  ${className}`}
            >
                <div
                    className={`${styles["select__text"]}  ${showOptionList ? styles["select__text--active"] : ""
                        } ${selectClass}`}
                    onClick={handleListDisplay}
                >
                    {selectedValue ? selectedValue : `-Select-`}
                </div>
                {showOptionList && (<ul className={`${styles["select__options"]} ${dropdownClass}`}>
                    {optionsList.map((option, index) => {
                        console.log(option.label,selectedValue , option.label == selectedValue)
                        return (
                            <li
                                className={`${styles["select__option"]} ${option.label === selectedValue
                                    ? showIcon ?styles["select__option--active-flag"] :styles["select__option--active"]
                                    : ""
                                    }`}
                                data-value={option.label}
                                key={index}
                                onClick={optionClick}
                                id={option.id && option.id}
                            >
                                {option.label}
                            </li>
                        );
                    })}
                </ul>
                )}</div>
                : <select
                    className={`${styles["native-select"]}`}
                    onChange={(event) => handleSelect(event.target.value)}
                >
                    {optionsList &&
                        optionsList.map((item) => <option selected={selectedValue === item.label ? "selected" : ""}>{item.label}</option>)}
                </select>}
        </div>
    )
}

export default UpgradeDropdown;